export const SET_SALARY = "setSalary";

export const setSalary = (payload: any) => {
  return {
    type: SET_SALARY,
    payload,
  };
};
